import { render, staticRenderFns } from "./solutionDetail.vue?vue&type=template&id=13d44ca5&scoped=true"
import script from "./solutionDetail.vue?vue&type=script&lang=js"
export * from "./solutionDetail.vue?vue&type=script&lang=js"
import style0 from "./solutionDetail.vue?vue&type=style&index=0&id=13d44ca5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d44ca5",
  null
  
)

export default component.exports